import React from 'react'

import FormManager from "../../common/form-manager"
import Stepper from '../../../../core/gd-components/stepper/stepper'

type Props = {
    className?  : string

    form        : FormManager
    name        : string
    minValue    : number
    maxValue    : number

    onChange?   : {(value: number): void}
}

export default class StepperFormElement extends React.Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    componentDidMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue: number) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue)
        this.props.onChange?.(newValue)
    }

    render() {
        let value = this.props.form.getValue(this.props.name)
        const classes = Classes("form-element-stepper", this.props.className)

        return <Stepper className   = {classes}
                        value       = {value ? value : 0}
                        minValue    = {this.props.minValue}
                        maxValue    = {this.props.maxValue}
                        onChange    = {this.onChange}/>;
    }
}